import React from "react"
import { graphql, PageProps } from "gatsby"

import SEO from "../components/seo"
import Grid from "../components/grid"
import GridImage from "../components/gridImage"
import GridAnimation from "../components/gridAnimation"
import Sidebar from "../components/sidebar"
import {pictures} from "../data/pictures.json"
import { GatsbyImageFluidProps } from "gatsby-image"
import Helmet from "react-helmet";

class GridPage extends React.Component<PageProps<any>, {}> {
    sidebar: React.RefObject<any>;
    activePictureComponent: GridImage | null = null;
    constructor(props) {
        super(props);
        this.state = { activePictureComponent: null };
        this.sidebar = React.createRef();
        this.handlePictureSelect = this.handlePictureSelect.bind(this);
        this.handlePictureCollapse = this.handlePictureCollapse.bind(this);
    }
    handlePictureSelect(picture: PictureInfo, src: string, index: number, component: GridImage) {
        if(this.activePictureComponent !== null && this.activePictureComponent !== component)
            this.activePictureComponent.collapse();
        this.sidebar.current.setPicture(picture, src, index % 4 === 2);
        this.activePictureComponent = component;
    }
    //Only if the picture is collapsed manually by clicking on it
    handlePictureCollapse(picture: PictureInfo, component: GridImage) {
        this.sidebar.current.close();
        this.activePictureComponent = null;
    }
    render() {
        return (
          <>
          <SEO title={"Fractal Collection"} />
              <Helmet>
                  <link rel={"stylesheet"} href={"/styles/fractals.css"}></link>
              </Helmet>
          <header className={"fractalsHeader"}>
              <span>View project on Github</span>
              <a href="https://github.com/CakeWithSteak/fpf" className="infoIcon" title={"View project on GitHub"}>
                <img src={"/icons/github-mark-light.png"} width={64} height={64} />
              </a>
          </header>
          <div className={"fractalsContent"}>
              <main>
                  <Grid>
                      {this.props.data.allFile.edges.sort((a, b) => a.node.name.localeCompare(b.node.name)).map(({ node }, index) => {
                          if(node.extension == "mp4") {
                              return (
                                <GridAnimation src={node.publicURL}
                                               pictureInfo={pictures.find(p => p.filename === node.name)}
                                               key={node.name}
                                               index={index}
                                               onEnlarge={this.handlePictureSelect}
                                               onCollapse={this.handlePictureCollapse}
                                />
                              )
                          }
                          return (
                            <GridImage fluid={node.childImageSharp.fluid}
                                       originalSrc={node.childImageSharp.original.src}
                                       pictureInfo={pictures.find(p => p.filename === node.name)}
                                       key={node.name}
                                       index={index}
                                       onEnlarge={this.handlePictureSelect}
                                       onCollapse={this.handlePictureCollapse}
                            />
                          )})}
                  </Grid>
                  <Sidebar ref={this.sidebar}/>
              </main>
          </div>
          </>
        )
    }
}
export const query = graphql`
    query {
        allFile(filter: {dir: {regex: "/images/showcase/"}}) {
            edges {
                node {
                    name
                    extension
                    publicURL
                    childImageSharp {
                        fluid(maxWidth: 1000, quality: 95, srcSetBreakpoints: [200]) {
                            ...GatsbyImageSharpFluid
                        }
                        original {
                            src
                        }
                    }
                }
            }
        }
    }
`

export default GridPage